import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import {
  CONFIRM_EMAIL_PATH,
  FORGOT_PASSWORD_PATH,
  HOME_PATH,
  PRIVACY_POLICY,
  RESET_PASSWORD_PATH,
  SEND_CONFIRM_EMAIL_PATH,
  SIGN_IN_PATH,
  SIGN_UP_PATH,
  APPS_OFFERS_CREATE_PATH,
  APPS_OFFERS_PATH,
  TOS,
  APPS_CREATE_PATH,
  APPS_EDIT_DETAILS_PATH,
  APPS_VIEW_PATH,
  USERS_MANAGEMENT_PATH,
  APPS_OFFERS_VIEW_PATH,
  APPS_OFFERS_EDIT_PATH,
  APPS_DEALS_PATH,
  APPS_DEALS_VIEW_PATH,
  APPS_DEALS_VIEW_LOGS_PATH,
  JOIN_OFFER_PATH,
  APPS_TASKS_CREATE_PATH,
  APPS_EDIT_CATEGORIES_PATH,
  APPS_TASKS_PATH,
  APPS_TASKS_VIEW_PATH,
  APPS_TASKS_EDIT_PATH,
  APPS_PATH,
  APPS_EDIT_REWARDS_PATH,
  APPS_EDIT_INTEGRATION_PATH,
  APPS_DEALS_EDIT_PATH,
  STATISTICS_PATH,
  APPS_STATISTICS_PATH,
  APPS_TASKS_VIEW_LOGS_PATH,
  PUBLIC_APP_VIEW_PATH, MARKETPLACE_PATH, MARKETPLACE_APP_OFFERS_PATH
} from './paths';
import { ProtectedRoutes } from 'app/components/common/protected-routes/protected-routes';
import { PublicAppPage } from 'app/components/marketplace/public-app-page';
import { SignIn } from '../components/authentication/sing-in/sign-in';
import { SignUp } from '../components/authentication/sign-up/sign-up';
import { SendConfirmationEmail } from '../components/authentication/confirm-email/send-confirmation-email';
import { VerifyEmail } from '../components/authentication/confirm-email/verifyEmail';
import { ForgotPassword } from '../components/authentication/forgot-password/forgot-password';
import { ResetPassword } from '../components/authentication/reset-password/reset-password';
import { Tos } from '../components/pages/privacy-policy/tos';
import { OpenRoutes } from 'app/components/common/open-routes/open-routes';
import { PrivacyPolicy } from '../components/pages/privacy-policy/privacy-policy';
import { NotFound } from 'app/components/common/not-found/not-found';
import { VersionedFooter } from '../layouts/components/footer';
import { UserContainer } from '../components/management/users/user-container';
import { AppsCreatePage } from 'app/components/management/apps/create/apps-create-page';
import { AppsEditDetails } from 'app/components/management/apps/settings/edit/apps-edit-details';
import { AppViewPage } from 'app/components/management/apps/settings/view/app-view-page';
import { OfferCreatePage } from 'app/components/management/apps/offers/create/offer-create-page';
import { MyOffersList } from 'app/components/management/apps/offers/list/my-offers-list';
import { DealsRequestPage } from 'app/components/management/apps/deals/join/deals-request-page';
import { MyDealsList } from 'app/components/management/apps/deals/list/my-deals-list';
import { DealViewPage } from 'app/components/management/apps/deals/view/deal-view-page';
import { DealsLogsPage } from 'app/components/management/apps/deals/logs/deals-logs-page';
import { AppCategoriesPage } from 'app/components/management/apps/settings/categories/app-categories-page';
import { OffersViewPage } from 'app/components/management/apps/offers/view/offers-view-page';
import { OfferEditPage } from 'app/components/management/apps/offers/edit/offer-edit-page';
import { TaskCreatePage } from 'app/components/management/apps/tasks/create/task-create-page';
import { TasksListPage } from 'app/components/management/apps/tasks/list/tasks-list-page';
import { TaskViewPage } from 'app/components/management/apps/tasks/view/task-view-page';
import { TaskEditPage } from 'app/components/management/apps/tasks/edit/task-edit-page';
import { TabsPageLayout } from 'app/components/management/apps/tabs-page-layout';
import { AppPreview } from 'app/components/management/apps/preview/app-preview';
import { AppRewardsPage } from 'app/components/management/apps/settings/rewards/app-rewards-page';
import { AppsEditIntegration } from 'app/components/management/apps/settings/edit/apps-edit-integration';
import { DealEditPage } from 'app/components/management/apps/deals/edit/deal-edit-page';
import { StatisticsPage } from 'app/components/statistics/statistics-page';
import { AppsStatisticsPage } from 'app/components/management/apps/statistics/statistics-page';
import { TasksLogsPage } from 'app/components/management/apps/tasks/logs/tasks-logs-page';
import { MarketplaceAppsList } from 'app/components/marketplace/marketplace-apps-list';
import { MarketplaceAppOffersList } from 'app/components/marketplace/marketplace-app-offers-list';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/** Non Authenticated Routes **/}
      <Route element={<OpenRoutes />}>
        <Route path={SIGN_UP_PATH} element={<SignUp />} />
        <Route path={SIGN_IN_PATH} element={<SignIn />} />
        <Route path={SEND_CONFIRM_EMAIL_PATH} element={<SendConfirmationEmail />} />
        <Route path={CONFIRM_EMAIL_PATH} element={<VerifyEmail />} />
        <Route path={FORGOT_PASSWORD_PATH} element={<ForgotPassword />} />
        <Route path={RESET_PASSWORD_PATH} element={<ResetPassword />} />
      </Route>

      {/** Authenticated Routes **/}
      <Route element={<ProtectedRoutes renderFooter={() => <VersionedFooter />} />}>
        <Route path={MARKETPLACE_PATH} element={<MarketplaceAppsList />} />
        <Route path={MARKETPLACE_APP_OFFERS_PATH} element={<MarketplaceAppOffersList />} />
        <Route path={PUBLIC_APP_VIEW_PATH} element={<PublicAppPage />} />
        <Route path={JOIN_OFFER_PATH} element={<DealsRequestPage></DealsRequestPage>}></Route>
        <Route path={USERS_MANAGEMENT_PATH} element={<UserContainer />}></Route>
        <Route path={STATISTICS_PATH} element={<StatisticsPage />}></Route>

        <Route path={APPS_CREATE_PATH} element={<AppsCreatePage />}></Route>
        <Route path={APPS_PATH} element={<TabsPageLayout />}>
          <Route index element={<AppPreview></AppPreview>} />

          <Route
            path={APPS_EDIT_INTEGRATION_PATH}
            element={<AppsEditIntegration></AppsEditIntegration>}
          />

          <Route path={APPS_TASKS_PATH} element={<TasksListPage />}></Route>
          <Route path={APPS_TASKS_CREATE_PATH} element={<TaskCreatePage />}></Route>
          <Route path={APPS_TASKS_VIEW_PATH} element={<TaskViewPage />} />
          <Route path={APPS_TASKS_VIEW_LOGS_PATH} element={<TasksLogsPage />} />
          <Route path={APPS_TASKS_EDIT_PATH} element={<TaskEditPage />} />

          <Route path={APPS_OFFERS_PATH} element={<MyOffersList />}></Route>
          <Route path={APPS_OFFERS_CREATE_PATH} element={<OfferCreatePage />}></Route>
          <Route path={APPS_OFFERS_VIEW_PATH} element={<OffersViewPage />}></Route>
          <Route path={APPS_OFFERS_EDIT_PATH} element={<OfferEditPage />}></Route>

          <Route path={APPS_DEALS_PATH} element={<MyDealsList />}></Route>
          <Route path={APPS_DEALS_VIEW_PATH} element={<DealViewPage></DealViewPage>}></Route>
          <Route path={APPS_DEALS_VIEW_LOGS_PATH} element={<DealsLogsPage></DealsLogsPage>} />
          <Route path={APPS_DEALS_EDIT_PATH} element={<DealEditPage></DealEditPage>} />

          <Route path={APPS_VIEW_PATH} element={<AppViewPage />}></Route>
          <Route path={APPS_EDIT_CATEGORIES_PATH} element={<AppCategoriesPage />}></Route>
          <Route path={APPS_EDIT_REWARDS_PATH} element={<AppRewardsPage />}></Route>

          <Route path={APPS_EDIT_DETAILS_PATH} element={<AppsEditDetails />}></Route>
          <Route path={APPS_STATISTICS_PATH} element={<AppsStatisticsPage />}></Route>
        </Route>
      </Route>

      {/** Public Routes **/}
      <Route path={TOS} element={<Tos />} />
      <Route path={PRIVACY_POLICY} element={<PrivacyPolicy />} />
      <Route path="*" element={<NotFound />} />
    </>
  )
);

export default router;
